module.exports = __webpack_public_path__ + "/dot_com_ui/img/no-image-available-ba91825aa6564c63ad0da366e7e4ba5a.gif";


//////////////////
// WEBPACK FOOTER
// ./shared/interim/product-list/item/no-image-available.gif
// module id = 849
// module chunks = 0